import * as cookieHelper from "../helpers/cookie"
import * as cookieNames from "../booking/constants/Cookies"
import stickyDatepicker from "./sticky-datepicker"
import { trackTravelPlanner } from "../helpers/tracking"
import * as endpoint from "../booking/constants/Endpoints"
import axios from "axios"
import { hosts } from "../shared/itinerary/itinerary-module"
import { DateTime } from "luxon"

var rtime
var timeout = false
var delta = 50

window.onscroll = function () {
  stickToTop()
}
window.onresize = function () {
  rtime = new Date()
  if (timeout === false) {
    timeout = true
    setTimeout(handleResize, delta)
  }
}
var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop

var followFlightInput = document.getElementById("followFlight")
if (followFlightInput) {
  followFlightInput.addEventListener("click", (e) => e.stopPropagation()) // stops the trigger of onclick on the sticky header when clicking the toggle on TP
  followFlightInput.addEventListener("change", toggleFollowFlight)
}

var followFlightSwitch = document.getElementById("stickyFollowFlightSwitch")
if (followFlightSwitch) {
  followFlightSwitch.addEventListener("click", () => {
    var followFlightInput = document.getElementById("followFlight")
    if (followFlightInput) {
      if (!followFlightInput.checked) {
        let flightId = followFlightInput.getAttribute("data-flightId")
        trackTravelPlanner("track-event.generic", "follow flight - click", "toggle - floating header", flightId)
      }
    }
  })
}

const now = new Date()
const seconds = now.getSeconds()
const msTimeout = (60 - seconds) * 1000 // amount of seconds until 0 seconds on the clock. Used to sync the two places we're updating flightinfo every minute
setTimeout(() => {
  handleFlightInfoUpdate()
  setInterval(() => {
    handleFlightInfoUpdate()
  }, 60000) // update flight information in follow flight header every minute
}, msTimeout)

function toggleFollowFlight(e) {
  if (e.target) {
    let reactSlider = document.getElementsByClassName("followFlightReact")
    let slider = e.target.parentElement.getElementsByClassName("follow-flight__switch__slider")[0]
    if (
      (reactSlider && reactSlider.length > 0 && reactSlider[0].dataset.enableFollowFlight === "true") ||
      ((!reactSlider || reactSlider.length == 0) && slider)
    ) {
      let flightId = e.target.getAttribute("data-flightId")
      let followTracking = e.target.getAttribute("data-followTracking")
      let unfollowTracking = e.target.getAttribute("data-unfollowTracking")
      let estimatedPublicTime = e.target.getAttribute("data-estimatedPublicTime")
      if (e.target.checked) {
        let sliders = document.getElementsByClassName("follow-flight__switch__slider")
        for (var i = 0; i < sliders.length; i++) {
          sliders[i].classList.add("on")
          sliders[i].classList.remove("off")
        }
        if (followTracking) {
          try {
            eval(followTracking)
          } catch (error) {}
        }
        setFollowFlightCookie(flightId, estimatedPublicTime)
      } else {
        let sliders = document.getElementsByClassName("follow-flight__switch__slider")
        for (var i = 0; i < sliders.length; i++) {
          sliders[i].classList.add("off")
          sliders[i].classList.remove("on")
        }
        if (unfollowTracking) {
          try {
            eval(unfollowTracking)
          } catch (error) {}
        }
        removeFlightFromCookie(flightId)
      }
    }
  }
}

function setFollowFlightCookie(flightId, estimatedPublicTime) {
  const flight = { id: flightId, ept: estimatedPublicTime }
  let cookieData = [flight]
  let expiration = estimatedPublicTime
  let cookie = cookieHelper.getCookie(cookieNames.CPH_FOLLOW_FLIGHT)
  if (cookie) {
    let flights = cookie
    flights.push(flight)
    let sortedFlights = flights.sort((a, b) => (a.ept < b.ept ? -1 : a.ept > b.ept ? 1 : 0))
    let lastFlight = sortedFlights[sortedFlights.length - 1]
    expiration = lastFlight.ept
    cookieData = flights
  }
  // Cookie will be set server side the next time the page loads
  cookieHelper.setCookieWithExpiration(cookieNames.CPH_FOLLOW_FLIGHT, cookieData, expiration)
}

function removeFlightFromCookie(flightId) {
  let cookie = cookieHelper.getCookie(cookieNames.CPH_FOLLOW_FLIGHT)
  if (cookie) {
    let flights = cookie
    flights = flights.filter((f) => {
      return f.id !== flightId
    })

    if (flights.length > 0) {
      let sortedFlights = flights.sort((a, b) => (a.ept < b.ept ? -1 : a.ept > b.ept ? 1 : 0))
      let lastFlight = sortedFlights[sortedFlights.length - 1]
      let expiration = lastFlight.ept
      // Cookie will be set server side the next time the page loads
      cookieHelper.setCookieWithExpiration(cookieNames.CPH_FOLLOW_FLIGHT, sortedFlights, expiration)
    } else {
      cookieHelper.deleteCookie(cookieNames.CPH_FOLLOW_FLIGHT)
    }
  }
}

function stickToTop() {
  let mobileNavMode = document.getElementsByClassName("is-mobilenav-mode")[0]
  let miniBasketMode = document.getElementsByClassName("is-minibasket-mode")[0]
  let header = document.getElementsByClassName("follow-flight")[0]
  let sticky = 0
  let topHeight = 0
  if (!mobileNavMode || !miniBasketMode) {
    if (header) {
      sticky = header.offsetTop
      topHeight = header.clientHeight

      let destinationHeader = document.getElementsByClassName("departure-info__essentials__top")[0]
      if (destinationHeader && header.getAttribute("data-hideInitially") === "True") {
        if (0 >= destinationHeader.getBoundingClientRect().top) {
          header.classList.add("sticky")
          header.parentElement.style.display = "block"
        } else {
          header.classList.remove("sticky")
          header.parentElement.style.display = "none"
        }
      } else {
        if (window.pageYOffset > sticky) {
          header.classList.add("sticky")
        } else {
          header.classList.remove("sticky")
        }
      }

      let wrapper = document.getElementsByClassName("follow-flight__wrapper")[0]
      if (wrapper) {
        wrapper.style.height = topHeight + "px"
      }
    }
  }

  let st = window.pageYOffset || document.documentElement.scrollTop
  let upscroll = st < lastScrollTop
  lastScrollTop = st <= 0 ? 0 : st

  let siteHeader = document.getElementsByClassName("site-header")[0]
  let siteHeader2 = document.getElementsByClassName("site-header")[1]
  let isArrivalsDeparturesPage = document.getElementsByClassName("js--arrivals-departures-page-module").length > 0
  let isParkingPage = document.getElementsByClassName("js-module-parking-root").length > 0
  if (siteHeader) {
    let isItineraryPage = document.getElementsByClassName("js-itinerary-module").length > 0
    let searchOpen = document.getElementsByClassName("search-section is-active").length > 0
    var newScrollPos = document.documentElement.scrollTop || document.body.scrollTop
    let notificationBanners = document.querySelectorAll("div.notifications:not(.hide)")
    let noticeBannerHeight = 0
    let bannerBottom = null
    if (notificationBanners.length > 0) {
      let notificationBanner = notificationBanners[notificationBanners.length - 1]
      if (notificationBanner) {
        const notificationVersion = notificationBanner.dataset.notificationVersion
        const notificationCookie = cookieHelper.getCookie(notificationVersion)
        if (notificationCookie != "closed") {
          bannerBottom = notificationBanner.getBoundingClientRect().bottom
          noticeBannerHeight = notificationBanner.offsetHeight
        }
      }
    }
    if (!searchOpen) {
      if (!isArrivalsDeparturesPage && !isItineraryPage && (mobileNavMode || miniBasketMode || (upscroll && window.pageYOffset > sticky))) {
        siteHeader.classList.remove("is-home-new")
        siteHeader.classList.remove("is-home")
        if (isParkingPage) {
          siteHeader.classList.add("is-sticky")
        } else {
          siteHeader.classList.add("is-sticky-new")
        }
        siteHeader.style.top = topHeight + "px"
      } else {
        if (newScrollPos > document.getElementsByClassName("site-header-wrapper")[0]?.offsetHeight + noticeBannerHeight) {
          if (isArrivalsDeparturesPage || isItineraryPage || isParkingPage) {
            siteHeader.classList.add("is-home")
            siteHeader.classList.remove("is-home-new")
          } else {
            siteHeader.classList.add("is-home-new")
            siteHeader.classList.remove("is-home")
          }
          siteHeader.classList.remove("is-sticky-new")
          siteHeader.classList.remove("is-sticky")
          siteHeader.style.top = null
        }
      }
    }
    let siteHeaderWrapper = document.getElementsByClassName("site-header-wrapper")[0]
    if (siteHeaderWrapper) {
      let headerHeight = siteHeader.clientHeight
      if (siteHeader2) {
        let searchSection = document.getElementsByClassName("search-section")[0]
        if (searchSection) {
          if (searchSection.classList.contains("is-active")) {
            headerHeight = siteHeader2.clientHeight
          }
        }
      }
      siteHeaderWrapper.style.height = headerHeight + "px"
    }

    if (noticeBannerHeight > 0) {
      if (0 <= bannerBottom) {
        siteHeader.classList.add("is-home")
        siteHeader.classList.remove("is-sticky-new")
        siteHeader.classList.remove("is-sticky")
        siteHeader.style.top = null
      }
    }
  }
  if (isArrivalsDeparturesPage) {
    stickyDatepicker()
  }
}

function handleResize() {
  if (new Date() - rtime < delta) {
    setTimeout(handleResize, delta)
  } else {
    timeout = false
    let siteHeader = document.getElementsByClassName("site-header")[0]
    let siteHeader2 = document.getElementsByClassName("site-header")[1]
    if (siteHeader) {
      let siteHeaderWrapper = document.getElementsByClassName("site-header-wrapper")[0]
      if (siteHeaderWrapper) {
        let headerHeight = siteHeader.clientHeight
        if (siteHeader2) {
          let searchSection = document.getElementsByClassName("search-section")[0]
          if (searchSection) {
            if (searchSection.classList.contains("is-active")) {
              headerHeight = siteHeader2.clientHeight
            }
          }
        }
        siteHeaderWrapper.style.height = headerHeight + "px"
      }
    }
  }
}

async function handleFlightInfoUpdate() {
  const body = document.getElementsByTagName("body")[0] // it complains about document.body for some reason, even in a null check
  if (body) {
    const followFlightHeader = document.getElementById("follow-flight")
    if (followFlightHeader) {
      const flightId = followFlightHeader.dataset.flightId
      const language = body.dataset.language || "da"
      if (flightId && language && hosts) {
        const response = await axios.get(endpoint.FLIGHT_INFO_SOLR(hosts, language, flightId))
        if (response && response.data) {
          const flightInfo = JSON.parse(response.data)
          if (flightInfo != null) {
            // update data in follow flight header
            const gateinfo = followFlightHeader.querySelector("#gate-info")
            const flightTime = followFlightHeader.querySelector("#flight-time")
            const flightDate = followFlightHeader.querySelector("#flight-date")
            const flightTerminal = followFlightHeader.querySelector("#flight-terminal")
            const flightGate = followFlightHeader.querySelector("#flight-gate")

            const parsedDate = DateTime.fromISO(flightInfo.EstimatedPublicTime).setLocale(language)
            const time = parsedDate.toFormat("HH:mm")
            const date = parsedDate.toFormat("d. MMM yyyy")

            if (gateinfo && flightInfo.status) {
              gateinfo.innerHTML = flightInfo.status
              gateinfo.classList = []
              gateinfo.classList.add("gateinfo")
              gateinfo.classList.add(flightInfo.statusClass)
            }
            if (flightTime) {
              flightTime.innerHTML = time
            }
            if (flightDate) {
              flightDate.innerHTML = date
            }
            if (flightTerminal && flightInfo.CheckInTerminal) {
              flightTerminal.innerHTML = flightInfo.CheckInTerminal
            }
            if (flightGate && flightInfo.Gate) {
              flightGate.innerHTML = flightInfo.Gate
            }
          }
        }
      }
    }
  }
}
